import { Component, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { RaBadgeComponent } from 'ra-ui';
import { OrderEntity } from '@domain';
import { OrderMainService } from '../../pages/main/services/order-main.service';

@Component({
    selector: 'order-card',
    templateUrl: 'order-card.component.html',
    styleUrl: 'order-card.component.scss',
    standalone: true,
    imports: [TranslatePipe, RaBadgeComponent],
})
export class OrderCardComponent {
    public order = input.required<OrderEntity>();
    public active = input<boolean>(false);
    public isMouseInsideContainer = input<boolean>(false);

    // * [Injects]
    public orderMainService = inject(OrderMainService);
}
